<template>
  <v-main class="d-flex align-center justify-center h-screen">
    <v-card width="1100" class="pa-4 error-card">
      <v-card-title class="screen-title"> システムエラー </v-card-title>
      <v-card-text class="pt-4">
        指定のページは一時的に利用できないか、管理者によってアカウントが削除された可能性があります。<br />
        ご利用を続ける場合は、再度ログインしてください。<br /><br />
        問題が解決しない場合は下記までお問い合わせください。<br />
        お問い合わせ先：サービスコントロールセンター <br />
        電話番号：0120-993-600(無料)<br />
        受付時間：24時間365日
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn to="/" color="primary" variant="flat">HOME</v-btn>
      </v-card-actions>
    </v-card>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SystemErrorView",
});
</script>
